import { Check } from "lucide-react";
import { applicationSteps } from "@/modules/candidate/constants/candidateApplication.constants";

interface StepIndicatorProps {
  activeStepIndex: number;
}

export default function StepIndicator({ activeStepIndex }: StepIndicatorProps) {
  return (
    <div className="border-b bg-gray-50 px-6 py-5">
      <div className="mx-auto flex max-w-2xl items-start">
        {applicationSteps.map((step, index) => {
          const isCompleted = activeStepIndex > index;
          const isActive = activeStepIndex === index;

          return (
            <div key={step.id} className="flex flex-1 items-start last:flex-none">
              <div className="flex min-w-20 flex-col items-center text-center">
                <div
                  className={`flex h-9 w-9 items-center justify-center rounded-full border-2 text-sm font-semibold transition-colors ${
                    isCompleted
                      ? "border-blue-600 bg-blue-600 text-white"
                      : isActive
                        ? "border-blue-600 bg-white text-blue-600"
                        : "border-gray-300 bg-white text-gray-400"
                  }`}
                >
                  {isCompleted ? <Check className="h-4 w-4" /> : index + 1}
                </div>

                <p
                  className={`mt-2 hidden text-xs font-medium sm:block ${
                    isActive || isCompleted ? "text-blue-700" : "text-gray-400"
                  }`}
                >
                  {step.shortTitle}
                </p>
              </div>

              {index < applicationSteps.length - 1 && (
                <div className={`mt-4 h-0.5 flex-1 ${activeStepIndex > index ? "bg-blue-600" : "bg-gray-200"}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}